import { useEffect, useState } from "react";
import { Plus } from "lucide-react";

export function SupplierAutocomplete({ value, onChange, options = [], onCreate, allowCreate, testid, placeholder = "Cerca o crea fornitore" }) {
  const canCreate = allowCreate !== undefined ? allowCreate : !!onCreate;
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(value || "");
  const [panel, setPanel] = useState(null);
  useEffect(() => { setQ(value || ""); }, [value]);
  const ql = q.trim().toLowerCase();
  const matches = options.filter((o) => o.toLowerCase().includes(ql));
  const exact = options.some((o) => o.toLowerCase() === ql);
  const inp = "w-full border border-stone-300 bg-white px-3 py-2 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40";
  const doCreate = async () => {
    const ok = await onCreate(panel.name.trim(), { email: panel.email.trim(), phone: panel.phone.trim() });
    if (ok !== false) setPanel(null);
  };
  return (
    <div className="relative">
      <input data-testid={testid} className={inp} placeholder={placeholder} value={q}
        onChange={(e) => { setQ(e.target.value); onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && !panel && (ql || matches.length > 0) && (
        <div className="absolute z-30 mt-1 w-full max-h-48 overflow-auto bg-white border border-stone-200 rounded-sm shadow-lg">
          {matches.map((o) => (
            <button key={o} type="button" onMouseDown={(e) => { e.preventDefault(); onChange(o); setQ(o); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-stone-50">{o}</button>
          ))}
          {matches.length === 0 && !canCreate && <div className="px-3 py-2 text-xs text-stone-400">Nessun fornitore corrisponde</div>}
          {ql && !exact && canCreate && (
            <button type="button" data-testid={`${testid}-create`} onMouseDown={(e) => { e.preventDefault(); setPanel({ name: q.trim(), email: "", phone: "" }); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm text-brand font-semibold hover:bg-stone-50 border-t border-stone-100 flex items-center gap-1"><Plus size={13} /> Aggiungi nuovo fornitore: "{q.trim()}"</button>
          )}
        </div>
      )}
      {panel && (
        <div data-testid={`${testid}-create-panel`} className="absolute z-30 mt-1 w-full bg-white border border-brand/40 rounded-sm shadow-lg p-3 space-y-2">
          <p className="text-xs font-bold uppercase tracking-wide text-stone-500">Nuovo fornitore</p>
          <input data-testid={`${testid}-create-name`} className={inp} placeholder="Ragione sociale" value={panel.name} onChange={(e) => setPanel({ ...panel, name: e.target.value })} />
          <input data-testid={`${testid}-create-email`} className={inp} placeholder="Email (opzionale)" value={panel.email} onChange={(e) => setPanel({ ...panel, email: e.target.value })} />
          <input data-testid={`${testid}-create-phone`} className={inp} placeholder="Telefono (opzionale)" value={panel.phone} onChange={(e) => setPanel({ ...panel, phone: e.target.value })} />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setPanel(null)} className="text-xs font-semibold text-stone-500 px-3 py-1.5 rounded-full hover:bg-stone-100">Annulla</button>
            <button type="button" data-testid={`${testid}-create-confirm`} onClick={doCreate} disabled={!panel.name.trim()} className="text-xs font-semibold bg-brand text-white px-4 py-1.5 rounded-full hover:bg-brand-hover transition-colors disabled:opacity-40">Crea</button>
          </div>
        </div>
      )}
    </div>
  );
}
